import {
  TTranslationAppearanceForm,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  locale: {
    label: 'Sprache',
    tooltip: 'Ermöglicht es, die gewünschte Sprache und des Gebietsschemas für die Benutzeroberfläche auszuwählen.',
  },
  fontSize: {
    label: 'Skalierung',
    tooltip: 'Ermöglicht die Größe von Schrift und Bedienelement anzupassen.',
  },
  chartTimeFormat: {
    label: 'Zeitformat für Diagramme',
    tooltip: 'Legt fest, wie Daten und Zeitstempel auf der X-Achse der Diagramme angezeigt werden.',
  },
  unitSystem: {
    label: 'Einheitensystem',
    tooltip: 'Wählen Sie Ihre bevorzugten Messeinheiten (z. B. metrisch oder imperial) zur Anzeige der Werte aus.',
  },
  scaleOption: {
    label: 'Layout Skalierung',
    tooltip: 'Legt fest, wie die Skalierung des Shop-Layouts dargestellt werden soll.',
  },
  showOnlyAvailableApps: {
    label: 'Nur verfügbare Apps anzeigen?',
    tooltip: 'Blendet Apps aus, die nicht zur Verfügung stehen, um die Benutzeroberfläche übersichtlicher zu gestalten.',
  },
};

export default {
  subline: 'Ändere das Erscheinungsbild von Qmulus.',
  appearanceForm,
};
